export const bannerHeadingDefaults = {
  heading: 'Limited Time Offer',
  subheading: 'Don’t miss our best deal. Upgrade to ultra-fast Fiber Internet now.',
  theme: 'blue',
  legalHash: undefined,
  tooltip: undefined,
  isCentered: true,
  cta: {
    copy: 'Shop Now',
    url: 'https://frontier.com/buy'
  }
};
